import { FC, ReactNode, MouseEvent, useMemo } from 'react';
import Loader from './Loader';

type Props = {
  className?: string;
  type?: 'button' | 'submit';
  disabled?: boolean;
  onClick?: (event?:MouseEvent<HTMLButtonElement>) => void;
  size?: 'xsmall' | 'small' | 'default' | 'large';
  disableShadow?: boolean;
  children: ReactNode;
  loading?: boolean;
  style?: any;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  onPointerDownCapture?: (event: React.PointerEvent<HTMLButtonElement>) => void;
}

export const Button:FC<Props> = ({
  className = '', type = 'button', disabled = false, onClick = () => null,
  size = 'default', disableShadow = false, loading = false, style = {},
  onMouseEnter, onMouseLeave, onPointerDownCapture, children
}) => {

  const classes:any = useMemo(() => ({
    xsmall: 'text-xs py-1 px-2 rounded',
    small: 'text-sm p-2 rounded-lg',
    default: 'text-base px-4 py-3 rounded-2xl'
  }), []);

  return (
    <button
      className={`
        ${classes[size]}
        bg-gray-200
        font-semibold
        uppercase
        ${className}
        ${disabled || loading ? 'pointer-events-none' : ''}
      `}
      style={{
        boxShadow: disableShadow ? '' : 'inset -2px -3px 5px rgba(0, 0, 0, 0.5)',
        WebkitTapHighlightColor: 'transparent',
        ...style
      }}
      type={type}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onPointerDownCapture={onPointerDownCapture}
      disabled={disabled || loading}
    >
      {loading && <Loader />}
      {children}
    </button>
  )
}
